var map = {
	"./aparthotelclub/ic_tag_service.png": 44240,
	"./beachful/ic_tag_service.png": 18172,
	"./castlepedia/ic_tag_service.png": 60867,
	"./cocktayl/ic_tag_service.png": 37561,
	"./ic_tag_service.png": 50409,
	"./luxresortclub/ic_tag_service.png": 74406,
	"./parkful/ic_tag_service.png": 94635,
	"./prefabworld/ic_tag_service.png": 27748,
	"./rooftopclub/ic_tag_service.png": 95306,
	"./spaclub/ic_tag_service.png": 72841,
	"./worldcasino/ic_tag_service.png": 80386,
	"./zoopedia/ic_tag_service.png": 9110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49494;